module.exports = __webpack_public_path__ + "static/img/Jarrod-Wallace.f5f6055.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jarrod-Wallace.jpg
// module id = NFhX
// module chunks = 0